import { render, staticRenderFns } from "./DeclarationsObligatoires.vue?vue&type=template&id=1a7ae38d&scoped=true"
import script from "./DeclarationsObligatoires.vue?vue&type=script&lang=js"
export * from "./DeclarationsObligatoires.vue?vue&type=script&lang=js"
import style0 from "./DeclarationsObligatoires.vue?vue&type=style&index=0&id=1a7ae38d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7ae38d",
  null
  
)

export default component.exports